/**
 * Programmatic download with a chosen filename. Fetches into a blob so
 * `download` is honored (cross-origin presigned URLs ignore `download` on a
 * raw link).
 */
export async function triggerBrowserFileDownload(
  href: string,
  filename: string,
): Promise<void> {
  const res = await fetch(href);
  if (!res.ok) {
    throw new Error(`HTTP ${res.status}`);
  }
  const blob = await res.blob();
  const objectUrl = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = objectUrl;
  a.download = filename;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(objectUrl);
}
